/**
 * Route for `goal-reports`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { GoalReportsPage } from "../features/goal-reports/GoalReportsPage";

export const goalReportsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/goal-reports",
	component: GoalReportsPage,
});

export default goalReportsRoute;
